import { Avatar, Box, Button, Card, CardContent, CardMedia, Divider, List, ListItem, ListItemAvatar, ListItemText, Paper, Skeleton, Stack, Typography, alpha, useTheme } from "@mui/material"
import CoPresentIcon from '@mui/icons-material/CoPresent';
import AddCardIcon from '@mui/icons-material/AddCard';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard, EffectFlip, EffectCards } from 'swiper/modules';
import QRCode from "react-qr-code";
import { toCanvas, toPng } from 'html-to-image';
import 'swiper/css/navigation';
import moment from "moment";

import CustomTypography from "../../../core/components/ui/CustomTypography"
import CustomChipComponent from "../../../core/components/common/custom-chip.component"
import CustomButton from "../../../core/components/ui/CustomButton";

import { Grid } from "react-loader-spinner";
import { useEffect, useRef, useState } from "react";
import { EIDListComponent } from "../../eIDPlugin";
import useUserProfile from "../hooks/useUserProfile";
import OrganizationDetailsComponent from "../components/organization-details.component";

const AccountPage = () => {

    const {isLoadingViewUserAccount, userAccount, errorViewUserAccount, viewUserAccount} = useUserProfile();
    const [userAccountDetails, setUserAccountDetails] = useState(null)
    const {viewProfile, profileDetails} = useUserProfile();

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const org_uid = rbacStorage?.state?.currentProfile?.orgId || null;

    useEffect(() => {
        viewProfile()
    }, [])

    const theme = useTheme()

    useEffect(() => {
        viewUserAccount()
    }, [])

    useEffect(() => {
        if (userAccount) {
            setUserAccountDetails(userAccount.user)
        }
    }, [JSON.stringify(userAccount)])

    console.log('user aaaa', userAccount)

    return(
        <>
            <Box sx={{textAlign: "start", mt: 2}}>
                <CustomTypography 
                    variant="h3"
                    text={"Account Details"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"View and manage your Electronic IDs"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>
            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, mt: 3}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Stack
                    direction="row"
                    spacing={2}
                    flex={1}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                    >
                        {
                            isLoadingViewUserAccount ?
                                <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                            :
                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar sx={{width: 80, height: 80}} />
                                    </ListItemAvatar>
                                    <ListItemText sx={{pl: 2, width: '100%'}} primary={<Typography variant="h5">{`${userAccountDetails?.lastname}, ${userAccountDetails?.firstname} ${userAccountDetails?.middlename == null ? "" : userAccountDetails?.middlename}`}</Typography>} secondary={<Typography variant="subtitle2">{userAccountDetails?.email}</Typography>} />
                                </ListItem>
                            </List>
                        }
                    </Stack>

                    <Stack
                    direction="column"
                    spacing={2}
                    flex={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "end",
                        pr: 4
                    }}
                    >
                        <CustomChipComponent category="profileStatusStyles"
                            label={(userAccountDetails?.status === "Active") ? "Active" 
                                : 
                                    (userAccountDetails?.status === "Deactivated") ? "Deactivated"
                                :
                                    (userAccountDetails?.status === "Pending") ? "Pending"
                                :
                                    userAccountDetails?.status
                            }
                        />
                    </Stack>
                </Stack>
            </Paper>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, p: 3, mt: 3}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="h3"
                            text={"Personal Information"}
                            customStyles={{
                                marginBottom: 0, 
                                fontSize: 20,
                                fontWeight: 700
                            }}
                        />
                    </Box>
                    {/* <Stack
                    direction="column"
                    flex={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "end",
                    }}
                    >
                        <Button 
                            variant="outlined" 
                            startIcon={<BorderColorIcon />}
                            sx={{textTransform: 'capitalize'}}
                        >
                            Edit
                        </Button>
                    </Stack> */}
                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}
                    >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Lastname"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewUserAccount) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={userAccountDetails?.lastname}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Firstname"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewUserAccount) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={userAccountDetails?.firstname}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box sx={{display: "inline-grid"}} flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Middlename"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewUserAccount) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={userAccountDetails?.middlename == null ? "N/A" : userAccountDetails?.middlename}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>
                    <Box flex={1} />
                </Stack>

                <Stack
                    direction="row"
                    spacing={2}
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}
                    >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Contact Number"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewUserAccount) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={userAccountDetails?.contact_no == null ? "N/A" : userAccountDetails?.contact_no}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Email"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewUserAccount) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={userAccountDetails?.email}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>

                    <Box sx={{display: "inline-grid"}} flex={1}>
                        <CustomTypography 
                            variant="caption" 
                            text={"Birthdate"} 
                            customStyles={{
                                marginBottom: 0, 
                            }}
                        />

                        {(isLoadingViewUserAccount) ?
                            <Skeleton variant="text" height="35px" width="70%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                        :
                            <CustomTypography
                                variant="body1"
                                text={moment(userAccountDetails?.birthdate).format("MMMM DD, YYYY")}
                                customStyles={{
                                    marginBottom: 0, 
                                    fontWeight: 500,
                                }}
                            />
                        }
                    </Box>
                    <Box flex={1} />
                </Stack>
            </Paper>

            {/* Profile Details */}
           {org_uid &&
                <Box sx={{mt: 3}}>
                    <OrganizationDetailsComponent org_uid={org_uid}/>
                </Box>
           }

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, p: 3, mt: 3}}>
                <Stack
                direction="row"
                spacing={2}
                sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
                >
                    <Box flex={1}>
                        <CustomTypography 
                            variant="h3"
                            text={"Electronic IDs"}
                            customStyles={{
                                marginBottom: 0, 
                                fontSize: 20,
                                fontWeight: 700
                            }}
                        />
                    </Box>
                </Stack>
                <br />
                
                {
                    userAccount && 
                    <EIDListComponent user_id={userAccount.user.user_uid} />
                }
            </Paper>
           
           
        </>
    )
}

export default AccountPage